import { getLastDayOfMonth } from './getLastDayOfMonth';
import { IStringDate } from './types';

export const getISO8601EndOfMonth = (date: IStringDate): string => {
  const year = date.split('-')[0];
  const month = date.split('-')[1];
  const lastDayOfMonth = getLastDayOfMonth(date);
  return `${year}-${month}-${lastDayOfMonth}T23:59:59.999Z`;
};
